"use strict";

var _classCallCheck = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _possibleConstructorReturn = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _inherits = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

Object.defineProperty(exports, "__esModule", {
  value: true
});
/**
 * @file Created on Mon Feb 18 2019
 */

var DataObjectConverter_1 = require("../../core/conversions/DataObjectConverter");
/**
 * @author BPo
 */


var PromotionSimulationConverter =
/*#__PURE__*/
function (_DataObjectConverter_) {
  _inherits(PromotionSimulationConverter, _DataObjectConverter_);

  function PromotionSimulationConverter() {
    _classCallCheck(this, PromotionSimulationConverter);

    return _possibleConstructorReturn(this, _getPrototypeOf(PromotionSimulationConverter).apply(this, arguments));
  }

  return PromotionSimulationConverter;
}(DataObjectConverter_1.DataObjectConverter);

exports.PromotionSimulationConverter = PromotionSimulationConverter;